import LRUCache from 'lru-cache'

const cache = new LRUCache({
	max: 1000,
	maxAge: 1000 * 60 // 缓存一分钟
})

export default function (req, res, next) {
	/*if (process.env.NODE_ENV !== 'development') {
		const url = req.originalUrl, html = cache.get(url)
		// 个人中心不缓存
		if (url.endsWith('profile')) {
			if (html) {
				return res.end(html, 'utf-8')
			} else {
				res.original_end = res.end
				// 重写res.end
				res.end = data => {
					if (res.statusCode === 200) {
						// 设置缓存
						cache.set(url, data)
					}
					// 最终返回结果
					res.original_end(data, 'utf-8')
				}
			}
		}
	}*/
	next()
}